<template>
  <div class="d-flex justify-content-center px-3">
    <div class="mw-1091x col-12 bg-white-primary mt-3 pt-5 pb-2 pb-md-5 mx-3 mx-md-5 rounded-8">
      <form @submit="submitAccount">
        <div class="sign-up gap-4r gap-md-32px d-flex flex-column">
          <div class="sign-up__header">
            <div class="d-flex justify-content-center">
              <img alt="" src="@/assets/image/logo.svg" />
            </div>
            <h1 class="text-center size-20 mt-3 fw-bold mb-0">ログイン</h1>
            <div v-if="checkAccountValid" class="text-center mt-4 mb-3">
              <span
                class="text-danger bg-danger bg-opacity-10 border rounded-2 border-danger px-1 py-3"
              >
                {{ messageError }}
              </span>
            </div>
          </div>
          <div class="sign-up__body">
            <div class="row justify-content-center">
              <div class="col-11 col-md-5 pt-3">
                <label for="email-form" class="form-label size-12">メールアドレス</label>
                <input
                  id="email-form"
                  v-model="userInformation.email"
                  type="email"
                  class="form-control border-0 bg-silver-primary input-primary"
                  placeholder="メールアドレスを入力"
                />
              </div>
              <div class="col-11 col-md-5 pt-3">
                <label for="password-form" class="form-label size-12 fw-normal">パスワード</label>
                <div class="input-group position-relative">
                  <input
                    id="password-form"
                    v-model="userInformation.password"
                    :type="checkTypePassword ? 'text' : 'password'"
                    class="form-control border-0 rounded-2 bg-silver-primary input-primary"
                    placeholder="パスワードを入力"
                  />
                  <div class="position-absolute top-15 end-0 pe-3 cursor-pointer">
                    <img
                      v-show="!checkTypePassword"
                      src="@/assets/image/pass.svg"
                      @click="changeTypePass"
                    />
                    <img
                      v-show="checkTypePassword"
                      src="@/assets/image/view-pass.svg"
                      @click="changeTypePass"
                    />
                  </div>
                </div>
              </div>

              <div class="mw-576x col-12 size-12 mt-2r mt-md-a4 p-md-0">
                <p class="text-center mb-2">
                  <a
                    href="/candidate/forgot_password"
                    class="color-blue-primary text-decoration-none"
                  >
                    パスワードをお忘れの方はこちら
                    <img src="@/assets/images/icons/arrow-right-blue.svg" />
                  </a>
                </p>
                <div class="row justify-content-center">
                  <button class="btn-signup btn btn-primary col-md-6 h-3" type="submit">
                    ログイン
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="sign-up_footer text-center border-top pt-3">
            <a
              :href="CANDIDATE_SIGN_UP_PATH"
              class="text-decoration-none color-blue-primary mt-md-a4"
            >
              会員登録がお済みでない方はこちら
              <img alt="" class="me-2" src="@/assets/images/icons/arrow-right-blue.svg" />
            </a>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, ref, onMounted, computed } from 'vue';
import { useAuthStore } from '@/stores/auth.store';
import { login } from '@/apis/candidate';
import { verifyAccountType } from '@/types/api/session';
import { CANDIDATE_SIGN_UP_PATH } from '@/constant/routers/path';
import 'bootstrap/dist/js/bootstrap.min.js';

const checkTypePassword = ref<boolean>(false);
const authStore = useAuthStore();
const checkAccountValid = ref<boolean>(false);
const messageError = ref('');

const userInformation = reactive<verifyAccountType>({
  email: '',
  password: '',
  redirect_to: new URLSearchParams(window.location.search).get('redirect_to'),
});

const redirectToPanel = () => {
  window.location.href = '/panel/';
};

const loggedIn = computed(() => authStore.isAuthenticated);

onMounted(async () => {
  document.querySelectorAll('.modal-backdrop').forEach((backdrop) => backdrop.remove());
  if (loggedIn.value) {
    redirectToPanel();
  }
});

const submitAccount = async (e: Event) => {
  e.preventDefault();

  const response = await login(userInformation);
  if (response.status && response.status === 200) {
    localStorage.setItem('access_token', response.data?.token);

    await authStore.checkAuthenticated(true);

    if (response.data?.redirect_url) {
      window.location.href = response.data.redirect_url;
    } else if (document.referrer.includes(window.location.host)) {
      window.location.href = document.referrer;
    } else {
      window.location.href = '/';
    }
  } else {
    messageError.value = response.data.field_error[0].message;
    checkAccountValid.value = true;
  }
};

const changeTypePass = () => {
  checkTypePassword.value = !checkTypePassword.value;
};
</script>
